import sdk from '@trazi/email/sdk/node';

export default sdk(process.env.EMAIL_SDK_SERVER_URL);
